export default __webpack_public_path__ + "static/media/update_login.c1645bff.svg";